import { render, staticRenderFns } from "./DispRedonda.vue?vue&type=template&id=0ff9b975"
import script from "./DispRedonda.vue?vue&type=script&lang=js"
export * from "./DispRedonda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports